import { useState } from 'react';

const useToggle = (initState?: boolean): [boolean, (override?: boolean) => void] => {
  const [isOn, setIsOn] = useState(initState || false);

  return [
    isOn,
    (override?: boolean) => {
      setIsOn(override !== undefined ? override : !isOn);
    },
  ];
};

export default useToggle;
